import {endOfURL} from "../../helpers/UrlHelper";

const DefaultRouteState = {
  user_role: ``,
  action:'loader',
  user:``,
  dashboard_menu:``,
  site_url:endOfURL(),
  dashboard: `dashboard`
};

export const MainRouteState = {data: DefaultRouteState}